import styled from 'styled-components'

import { Title5 } from 'components/fonts'
import mediaQueries from 'components/media-queries'
import e2eClasses from 'helpers/automation'

export const StyledContainer = styled.div.attrs(() => ({
  className: e2eClasses('corporate.agreementsLoginBox')
}))`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px 37px;
  background-color: ${({ theme }) => theme.colors.white};
  ${mediaQueries.mobile`
    padding: 14px 16px;
  `};
`

export const StyledLabel = styled.div.attrs(() => ({
  className: e2eClasses('corporate.agreementsLoginTitle')
}))`
  display: flex;
  align-items: end;
  & > ${Title5} {
    font-family: ${({ theme }) => theme.fonts.semiBold};
    margin: 0;
  }
`

export const IconContainer = styled.div.attrs(() => ({
  className: e2eClasses('corporate.agreementsLoginIcon')
}))`
  margin-right: 15px;
  align-items: center;
  svg {
    path {
      fill: ${({ theme }) => theme.colors.blue};
    }
  }
`

export const FormContainer = styled.div.attrs(() => ({
  className: e2eClasses('corporate.agreementsLoginFormBox')
}))`
  display: flex;
  flex-direction: column;
  padding: ${({ padding }) => (padding && padding) || '16px 0 0 0'};
`

export const Label = styled.span.attrs(props => ({
  className: props.e2eClass && `${e2eClasses('common.inputTitle')}${props.e2eClass}`,
  htmlFor: props.forId
}))`
  display: flex;
  font-size: 14px;
  letter-spacing: 0.87px;
  color: ${({ theme }) => theme.colors.doveGray};
  font-family: ${({ theme }) => theme.fonts.semiBold};
  padding: 8px 0;
`

export const ButtonWrapper = styled.div`
  width: 100%;
  padding-top: 14px;
`

export const StyledLink = styled.a.attrs(() => ({
  className: e2eClasses('corporate.agreementsForgetLink')
}))`
  display: flex;
  font-size: 14px;
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.blue};
  font-family: ${({ theme }) => theme.fonts.regular};
  margin: 6px 0 16px;
`
export const RecoveryLinkContainer = styled.div`
  display: flex;
`
